import join from 'lodash/join'
import map from 'lodash/map'
import type { ToastContextType } from '@ztechapps/common.hook'
import type { ChatBatchResult } from '@ztechapps/common.contract'

// Every batch mutation reports the same way: the succeeded count as a success, then each
// individual failure with its reason — a failure never stops the rest of the batch.
export const reportBatchOutcome = (
  { showSuccess, showError }: Pick<ToastContextType, 'showSuccess' | 'showError'>,
  noun: string,
  verb: string,
  result: ChatBatchResult
) => {
  if (result.succeededCount > 0) {
    showSuccess({ message: `${result.succeededCount} ${noun}(s) ${verb}.` })
  }

  if (result.failedCount > 0) {
    const failureList = join(
      map(result.failures, (failure) => `${failure.chatId} (${failure.reason})`),
      ', '
    )
    showError({ message: `${result.failedCount} ${noun}(s) failed: ${failureList}` })
  }
}
